import { ApiError } from "pages/admin-app/shared/models/response/api-errors";

import { useQuery } from "@tanstack/react-query";
import { getIndustrySpecialist } from "../services/industry-specialist-service";
import { GetIndustrySpecialistResponse } from "../models/response/get-industry-specialist-response";

interface Props {
  industrySpecialistId: number | string;
}

export function useIndustrySpecialist({ industrySpecialistId }: Props) {
  const { data, error, isLoading, isError, refetch } = useQuery<
    GetIndustrySpecialistResponse,
    ApiError
  >({
    queryKey: ["industrySpecialist", industrySpecialistId],
    queryFn: () => getIndustrySpecialist({ industrySpecialistId }),
  });

  const baseErrorResponse = error ? error.message : null;

  return {
    data,
    error: baseErrorResponse,
    isLoading,
    isError,
    refetch,
  };
}
